<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
            Palghar District Badminton Championship 2025
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center mb-5">
      <h2><span> G H Raisoni Memorial Palghar District Badminton Championship 2025</span></h2>
    </div>
    <div class="row justify-content-between">
      <div class="col-md-7">
        <p>
          <span class="text-dark">Dates:</span> 6th - 8th June
        </p>
        <p>
          <span class="text-dark"> Location:</span> Palghar, Maharashtra
        </p>
        <p>
          <span class="text-dark"> Organizer: </span> G. H. Raisoni Foundation
        </p>
        <p>
          <span class="text-dark"> Affiliated with: </span> Maharashtra Badminton Association
        </p>
        <p>
          <span class="text-dark"> Tournament Software:</span><a href="www.tournamentsoftware.com" target="_blank">
            www.tournamentsoftware.com</a>

        </p>

        <!-- <p>
                    <strong>Venue:</strong> Badminton Hall, Vidya Vikashi School, Fatherwadi, Vasai(E)
                </p> -->

        <h5 class="primary-purple">Overview</h5>

        <p>The championship witnessed overwhelming participation from budding and seasoned players across multiple age
          groups and categories. The tournament was organized with a strong emphasis on fair play, technical excellence,
          and youth engagement in sports.</p>
        <p><span class="text-dark">Total Participants:</span> Over 180+ players</p>
        <p><span class="text-dark">Categories:</span> Boys & Girls (U9 to U19), Men’s & Women’s Singles & Doubles
          (including MS 35+, MS 45+, MD 35+, MD 45+)</p>
        <p><span class="text-dark">Total Matches Played:</span> 333 matches</p>
        <p> <span class="text-dark">Total Shuttles Used: </span> Approx. 5787</p>

      </div>
      <div class="col-md-4">
        <div class="image-effect-3">
          <img
            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/palghar-district-aadminton-champ-25.webp"
            alt="GHRSCF">
        </div>
      </div>
      <h5 class="primary-purple"> Top Winners (Select Categories)</h5>
      <hr>
      <h6>Boys Singles</h6>
      <ul class="list-style list-style1 list-count  mb-3 ">
        <li><span class="text-dark">U9:</span> Aniruddh Kurup (SSBA)</li>
        <li><span class="text-dark">U11:</span> Rudra Manohar (SELF)</li>
        <li><span class="text-dark">U13:</span> Pratham Raut (AA)</li>
        <li><span class="text-dark">U15:</span> Pragnay Shinde (AA)</li>
        <li><span class="text-dark">U17:</span> Ruturaj Chipat (NBA)</li>
        <li><span class="text-dark">U19:</span> Ruturaj Chipat (NBA)</li>
      </ul>

      <h6>Girls Singles</h6>
      <ul class="list-style list-style1 list-count  mb-3 ">
        <li><span class="text-dark">U11 & U13:</span> Priya Amburle (SELF)</li>
        <li><span class="text-dark">U15:</span> Parinita Sonavane (AA)</li>
        <li><span class="text-dark">U17 & U19:</span> Prisha Shah (SELF)</li>
      </ul>
      <h6>Doubles Highlights</h6>
      <ul class="list-style list-style1 list-count  mb-3 ">
        <li><span class="text-dark">BD U17:</span> Pragnay Shinde & Pratham Raut (AA)</li>
        <li><span class="text-dark">GD U17:</span> Prisha Shah & Shanaya Tak (SELF/GBA)</li>
        <li><span class="text-dark">WD:</span> Devanshi Jagtap & Urvashi Sharma (SELF)</li>
        <li><span class="text-dark">MD:</span> Ian Lopes & Krish Desai (SELF/AA)</li>
      </ul>

      <h6>Veteran Categories</h6>
      <ul class="list-style list-style1 list-count mb-3 ">
        <li><span>MS 35+: </span> Manish Hadkar</li>
        <li><span>MD 35+: </span> Prasad Gokhale & Vivaswan Nimkar</li>
        <li><span>MS 45+: </span> Ajay Salvi</li>
        <li><span>MD 45+: </span> Ajay Salvi & Manoj Bhujbal</li>
      </ul>

      <h6>Performance Stats</h6>
      <ul class="list-style list-style1 list-count  mb-3 ">
        <li><span class="text-dark">Average Matches per Category:</span> 13–37</li>
        <li><span class="text-dark">Max. Matches in a Single Category:</span> Boys U15 (37 matches)</li>
        <li><span class="text-dark">Most Competitive Category:</span> Boys U15 & U17</li>
        <li><span class="text-dark">Shuttle Usage:</span> Average 1.7 shuttles per match</li>
      </ul>

      <h6>Walkovers/Retirements</h6>
      <p>Several matches were declared walkovers or had retirements due to injuries or non-attendance. These included
        key rounds in BD U17, BS U11, BS U13, GS U17, and MD 35.</p>
      <h6>Highlights</h6>
      <ul class="list-style list-style1 list-count  mb-3 ">
        <li>Exceptional sportsmanship by all age groups</li>
        <li>Strong participation from SELF, AA, SBIA, SSBA, NBA, and GBA clubs</li>
        <li>Smooth management through Tournament Planner software</li>
        <li>Local and regional talent was well represented and rewarded</li>
      </ul>
      <h6> Match Results</h6>
      <p>Complete match brackets, player stats, and media coverage available on:</p>
      <a href="www.tournamentsoftware.com" target="_blank"> www.tournamentsoftware.com</a>
       <div class="row  row-cols-1 row-cols-lg-4 mt-4">
                <div class="col-4">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/gondia-dist-badminton-tournament-final-results-sheet1.pdf" target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <!-- <h4>Gondia District badminton Championship 2024</h4> -->
                            </div>
                        </div>
                    </a>
                </div>
       </div>
      <div class="sec-title mt-5 text-center">
        <h2><span>Photo Gallery</span></h2>
        <hr>
      </div>
      <div class="text-end">
        <a href="https://drive.google.com/drive/folders/1ohq63xARu0uYX53uGxG0aEwmNEp4DCrR" class="cmn-button"> View
          More</a>
      </div>
      <div class="lightBox--gallery">
        <ul class="list-unstyled lightgallery row row-cols-1 justify-content-center row-cols-md-3">
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-1.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-1.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-1.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-2.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-2.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-2.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-3.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-3.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-3.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-4.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-4.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-4.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-5.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-5.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-5.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-6.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-6.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-6.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-7.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-7.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-7.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-8.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-8.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-8.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-9.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-9.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-9.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
          <li class="col"
            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-10.webp"
            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-10.webp">
            <a href="Javascript:void(0);">
              <img
                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-10.webp"
                alt="GHRSCF" title="GHRSCF" class="img-fluid">
              <div class="light-gallery-poster">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF">
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
